import { useResourceContext } from "@/layouts/ResourceContext";
import { useOne } from "@/hooks";
import { RESOURCE_TYPE_ADDONS } from "@/resources-def";
import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import DualFormLayout from "../common/DualFormLayout";
import { Spin } from 'antd';
import { ADDON_LEFT_COLS, ADDON_RIGHT_COLS, getAddonSchema } from "@/resources-def/addons-comp";


export const AddonDetailPanel = ({ resource="addons" }) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const { state, dispatch } = useResourceContext();
  const { selectedResources: [selectedAddon] } = state;
  const [val, setVal] = useState({});
  const { data, isLoading, isError } = useOne({
    resource: RESOURCE_TYPE_ADDONS, 
    id: selectedAddon?.id
  });

  useEffect(() => {
    if(data) {
      setVal({...data, versions : data.versions.map(version => version.version).join(" ,")})
    }
  }, [data])

  const columns = getAddonSchema(false);

  return (
    <div>
      {isLoading ? <Spin size="large" /> : <DualFormLayout columns={columns} values={val} leftCol={ADDON_LEFT_COLS} rightCol={ADDON_RIGHT_COLS}/>}
    </div>
  );
};
